@let corporateDesign = corporateDesignService.corporateDesign();
@let texts = textStore.texts();
@let fontColor =
  corporateDesignService.isDarkModeActive()
    ? corporateDesign.colorAdmixtures.dark_text_high
    : '';
@let minOnePaymentActive =
  configurationStore.getBooleanConfiguration(
    CONFIGURATION_SETTING_KEYS.IsDirectSaleActive
  ) ||
  configurationStore.getBooleanConfiguration(
    CONFIGURATION_SETTING_KEYS.IsSubscriptionActive
  );
@let labelIban =
  texts | filterTexts: ERelationType.iban : EEntityType.subscription | language;
@let labelBic =
  texts | filterTexts: ERelationType.bic : EEntityType.subscription | language;
@let labelCreditInstitute =
  texts
    | filterTexts: ERelationType.creditInstitute : EEntityType.subscription
    | language;
@if (corporateDesign && minOnePaymentActive) {
  <aw-section
    class="w-full"
    testIdAffix="account-payment-form"
    [darkModeColor]="corporateDesign.colorAdmixtures.dark_surface_01">
    <aw-section-header>
      <aw-section-headline>{{
        texts
          | filterTexts
            : ERelationType.paymentInfoLabel
            : EEntityType.privateArea
          | language
      }}</aw-section-headline>
    </aw-section-header>
    @if (
      configurationStore.getBooleanConfiguration(
        CONFIGURATION_SETTING_KEYS.IsDirectSaleActive
      ) &&
      configurationStore.getEnumConfiguration(
        CONFIGURATION_SETTING_KEYS.PaymentProvider,
        EPaymentProviders
      ) === EPaymentProviders.Logpay
    ) {
      <aw-section
        class="w-full"
        testIdAffix="account-payment-direct-form"
        [darkModeColor]="corporateDesign.colorAdmixtures.dark_surface_02">
        <aw-section-header>
          <aw-section-headline>{{
            texts
              | filterTexts
                : ERelationType.directTicketsLabel
                : EEntityType.privateArea
              | language
          }}</aw-section-headline>
          <aw-section-header-actions>
            <aw-button
              [id]="'add-direct-payment'"
              [type]="'button'"
              [style]="'primary-alt'"
              [disabledText]="
                texts
                  | filterTexts
                    : ERelationType.paymentInfoDirectAddDisabled
                    : EEntityType.privateArea
                  | language
              "
              [isDisabled]="!userStore.user()?.userId"
              (click)="addPaymentDirect()">
              <span
                [attr.data-testid]="'addPayment'"
                class="material-symbols-rounded">
                add
              </span>
              {{
                texts
                  | filterTexts
                    : ERelationType.paymentInfoDirectAddLabel
                    : EEntityType.privateArea
                  | language
              }}
            </aw-button>
          </aw-section-header-actions>
        </aw-section-header>
        @if (isLoadingDirectPayments()) {
          <div class="py-12">
            <aw-loading-animation></aw-loading-animation>
          </div>
        } @else {
          <aw-single-select
            id="payment-preference-choice"
            [hasBorder]="true"
            [valueAttribute]="'id'"
            [formControl]="preferenceControl"
            [template]="paymentOption"
            [options]="paymentMethods()"></aw-single-select>
        }
        <div class="text-base">
          <quill-view
            [style.color]="fontColor"
            [content]="
              texts
                | filterTexts
                  : ERelationType.directTicketsDescriptionText
                  : EEntityType.privateArea
                | language
            "
            [attr.data-testid]="'direct-payment-description'"></quill-view>
        </div>
      </aw-section>
    }
    @if (
      configurationStore.getBooleanConfiguration(
        CONFIGURATION_SETTING_KEYS.IsSubscriptionActive
      )
    ) {
      <aw-section
        class="w-full"
        testIdAffix="account-payment-subscription-form"
        [darkModeColor]="corporateDesign.colorAdmixtures.dark_surface_02">
        <aw-section-header>
          <aw-section-headline>{{
            texts
              | filterTexts
                : ERelationType.aboTicketsLabel
                : EEntityType.privateArea
              | language
          }}</aw-section-headline>
          <aw-section-header-actions>
            <aw-button
              [id]="'add-subscription-payment-logpay'"
              [type]="'button'"
              [style]="'primary-alt'"
              (click)="openBankDataDialog()">
              <span
                [attr.data-testid]="'addPaymentLogpay'"
                class="material-symbols-rounded">
                add
              </span>
              {{
                texts
                  | filterTexts
                    : ERelationType.paymentInfoAboAddLabel
                    : EEntityType.privateArea
                  | language
              }}
            </aw-button>
          </aw-section-header-actions>
        </aw-section-header>
        <div class="text-base">
          <quill-view
            [style.color]="fontColor"
            [content]="
              texts
                | filterTexts
                  : ERelationType.aboTicketsDescriptionText
                  : EEntityType.privateArea
                | language
            "
            [attr.data-testid]="'subscription-payment-description'"></quill-view>
        </div>
        <aw-single-select
          id="subscription-payment-preference-choice"
          [hasBorder]="true"
          [valueAttribute]="'id'"
          [formControl]="subscriptionPreferenceControl"
          [template]="subscriptionPaymentOption"
          [options]="bankDataStore.bankData()"></aw-single-select>
      </aw-section>
    }
  </aw-section>
}

<ng-template #paymentOption let-payment="data" let-index="index">
  <div class="flex w-full flex-row justify-between">
    <aw-payment-method-display
      [id]="'select-section-' + payment.type + '-text-' + index"
      [paymentMethod]="payment"></aw-payment-method-display>

    <div
      [attr.data-testid]="
        'select-section-' + payment.type + '-delete-' + index
      ">
      <aw-button
        tabindex="0"
        [id]="'remove-direct-payment'"
        [type]="'button'"
        [style]="'error'"
        (click)="openDeletePaymentMethodDialog(payment.id)">
        <span
          [attr.data-testid]="'removePayment'"
          class="material-symbols-rounded">
          delete
        </span>
      </aw-button>
    </div>
  </div>
</ng-template>

<ng-template #subscriptionPaymentOption let-bankData="data" let-index="index">
  @let labelClasses = 'font-semibold';
  @let valueClasses = 'col-span-3';
  <div class="grid w-full grid-cols-4 gap-2 pl-4">
    <div class="col-span-4">
      {{ bankData.firstName }} {{ bankData.lastName }}
    </div>
    <div [ngClass]="labelClasses">{{ labelIban }}</div>
    <div [ngClass]="valueClasses">{{ bankData.iban }}</div>
    <div [ngClass]="labelClasses">{{ labelBic }}</div>
    <div [ngClass]="valueClasses">{{ bankData.bic }}</div>
    <div [ngClass]="labelClasses">{{ labelCreditInstitute }}</div>
    <div [ngClass]="valueClasses">{{ bankData.creditInstitute }}</div>
  </div>
</ng-template>
